import { render, staticRenderFns } from "./forthStep.vue?vue&type=template&id=0dbfa032&scoped=true"
import script from "./forthStep.vue?vue&type=script&lang=js"
export * from "./forthStep.vue?vue&type=script&lang=js"
import style0 from "./forthStep.vue?vue&type=style&index=0&id=0dbfa032&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfa032",
  null
  
)

export default component.exports